export default {
  setSearchDate(state) {
    state.searchDate += 1;
  },
};
